import Button from '@mui/material/Button';
import { hexWithOpacity, toTitleCase } from 'common/utils';
import { colors } from 'styles/colors';
import useStyles from './styles';
import Circle from 'components/common/Circle/Circle';
import { EUserStatus } from 'enum';
import CustomText from 'components/common/CustomText/CustomText';

interface Props {
  status: EUserStatus;
}

export default function UserStatus({ status }: Props) {
  const styles = useStyles();

  const getStatusColor = (useStatus: EUserStatus) => {
    switch (useStatus) {
      case EUserStatus.BLOCKED:
        return colors.error;
      case EUserStatus.NOT_VERIFIED:
        return colors.warning;
      case EUserStatus.VERIFIED:
        return colors.success;
      default:
        return colors.text;
    }
  }

  return (
    <div>
      <Button
        className={styles.statusOuterButton}
        sx={{
          paddingLeft: 0,
          backgroundColor: hexWithOpacity(getStatusColor(status), 0.1),
          color: getStatusColor(status),
          '&&:hover': {
            bgcolor: hexWithOpacity(getStatusColor(status), 0.3),
            color: getStatusColor(status),
          },
        }}
      >
        <Circle
          boxSize={20}
          circleSize={6}
          color={getStatusColor(status)}
        />
        <CustomText text={toTitleCase(status)} color={getStatusColor(status)} fontSize={14} />
      </Button>
    </div>
  );
}
